import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { useEffect } from 'react'
import Hotjar from '@hotjar/browser'
import type { AppProps } from 'next/app'
import NextApp, { AppContext, AppInitialProps } from 'next/app'
import { Provider as NiceModalProvider } from '@ebay/nice-modal-react'

import '@nilohealth/core-ui/dist/assets/ReactToastify.css'

import App from 'src/App'
import AuthProvider from '@auth/auth-provider'

import { queryClient } from '@services/react-query'

const MyApp = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_HOTJAR_ID && process.env.NEXT_PUBLIC_HOTJAR_SV) {
      Hotjar.init(
        parseInt(process.env.NEXT_PUBLIC_HOTJAR_ID, 10),
        parseInt(process.env.NEXT_PUBLIC_HOTJAR_SV, 10)
      )
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NiceModalProvider>
          <ReactQueryDevtools position="bottom-right" />
          <App>
            <Component {...pageProps} />
          </App>
        </NiceModalProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}

// disable Automatic Static Optimization to handle newrelic on runtime (instead of buildtime)
MyApp.getInitialProps = async (context: AppContext): Promise<AppInitialProps> => {
  const ctx = await NextApp.getInitialProps(context)
  return ctx
}

export default MyApp
